<template>
  <div class="card-preview">
    <i class="el-icon-document card-preview-icon"></i>
    <div class="card-preview-content">
      <div class="card-preview-title">{{ cardTitle || 'Untitled Card' }}</div>
      <div v-if="showTags && cardTags && cardTags.length > 0" class="card-preview-tags">
        <el-tag
          v-for="(tag, index) in cardTags.slice(0, 3)"
          :key="index"
          size="mini"
          class="tag-mini"
        >
          {{ tag }}
        </el-tag>
        <span v-if="cardTags.length > 3" class="tag-more">+{{ cardTags.length - 3 }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardPreview',
  props: {
    cardTitle: {
      type: String,
      default: ''
    },
    cardTags: {
      type: Array,
      default: () => []
    },
    showTags: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.card-preview {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 12px;
  background: #f0f9ff;
  border: 1px solid #91d5ff;
  border-radius: 8px;
  margin-top: 8px;
  transition: all 0.3s ease;
  box-sizing: border-box;
  isolation: isolate;
}

.card-preview:hover {
  background: #e6f4ff;
  border-color: #69c0ff;
  box-shadow: 0 2px 8px rgba(24, 144, 255, 0.15);
}

.card-preview-icon {
  font-size: 20px;
  color: #1890ff;
  flex-shrink: 0;
  margin-top: 2px;
}

.card-preview-content {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.card-preview-title {
  font-size: 13px;
  font-weight: 600;
  color: #1890ff;
  line-height: 1.4;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.card-preview-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  align-items: center;
}

.tag-mini {
  font-size: 10px;
  height: 18px;
  line-height: 16px;
  padding: 0 6px;
}

.tag-more {
  font-size: 10px;
  color: #8c8c8c;
  font-weight: 500;
}
</style>
